import React from "react";
import styles from "./navigationBanner.module.scss";

const NavigationBanner = () => {
  return (
    <div className={styles.container}>
      <a
        className={styles.button}
        target={"_blank"}
        rel="noreferrer"
        href={"https://feedback.cake.work/"}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="24px"
          height="24px"
        >
          <g id="surface168508682">
            <path
              style={{
                stroke: "none",
                fillRule: "nonzero",
                fill: "rgb(100%,100%,100%)",
                fillOpacity: 1,
              }}
              d="M 11 0 L 11 3 L 13 3 L 13 0 Z M 4.222656 2.808594 L 2.808594 4.222656 L 4.929688 6.34375 L 6.34375 4.929688 Z M 19.777344 2.808594 L 17.65625 4.929688 L 19.070312 6.34375 L 21.191406 4.222656 Z M 12 5 C 8.144531 5 5 8.144531 5 12 C 5 14.769531 6.65625 17.101562 9 18.234375 L 9 21 C 9 22.09375 9.90625 23 11 23 L 13 23 C 14.09375 23 15 22.09375 15 21 L 15 18.234375 C 17.34375 17.101562 19 14.769531 19 12 C 19 8.144531 15.855469 5 12 5 Z M 12 7 C 14.773438 7 17 9.226562 17 12 C 17 14.183594 15.605469 16.023438 13.667969 16.707031 L 13 16.945312 L 13 21 L 11 21 L 11 16.945312 L 10.335938 16.707031 C 8.394531 16.023438 7 14.183594 7 12 C 7 9.226562 9.226562 7 12 7 Z M 0 11 L 0 13 L 3 13 L 3 11 Z M 21 11 L 21 13 L 24 13 L 24 11 Z M 4.929688 17.65625 L 2.808594 19.777344 L 4.222656 21.191406 L 6.34375 19.070312 Z M 19.070312 17.65625 L 17.65625 19.070312 L 19.777344 21.191406 L 21.191406 19.777344 Z M 19.070312 17.65625 "
            />
          </g>
        </svg>

        <span>Submit idea</span>
      </a>
      <a
        className={styles.button}
        target={"_blank"}
        rel="noreferrer"
        href={"https://309sov53iwj.typeform.com/to/Ti5MBxu8"}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="24px"
          height="24px"
        >
          <g id="surface168959698">
            <path
              style={{
                stroke: "none",
                fillRule: "nonzero",
                fill: "rgb(100%,100%,100%)",
                fillOpacity: 1,
              }}
              d="M 12 1 C 11.527344 1 11.054688 1.1875 10.65625 1.535156 C 10.242188 1.902344 9.625 2.417969 8.914062 3 L 6 3 C 4.898438 3 4 3.898438 4 5 L 4 6.914062 C 2.414062 8.15625 1.195312 9.105469 1.195312 9.105469 C 1.070312 9.199219 1 9.34375 1 9.5 L 1 21 C 1 22.101562 1.898438 23 3 23 L 21 23 C 22.101562 23 23 22.101562 23 21 L 23 9.5 C 23 9.34375 22.929688 9.199219 22.804688 9.105469 C 22.804688 9.105469 21.582031 8.15625 20 6.914062 L 20 5 C 20 3.898438 19.101562 3 18 3 L 15.089844 3 C 14.375 2.417969 13.757812 1.902344 13.34375 1.535156 C 12.945312 1.1875 12.472656 1 12 1 Z M 12 2 C 12.234375 2 12.46875 2.097656 12.679688 2.285156 C 12.90625 2.484375 13.191406 2.726562 13.515625 3 L 10.484375 3 C 10.808594 2.726562 11.09375 2.484375 11.320312 2.285156 C 11.53125 2.09375 11.765625 2 12 2 Z M 6 4 L 18 4 C 18.550781 4 19 4.449219 19 5 L 19 11.597656 C 16.761719 13.355469 13.953125 15.585938 12.683594 16.714844 C 12.5625 16.820312 12.308594 17 11.984375 17 C 11.746094 17 11.519531 16.902344 11.304688 16.714844 C 10.023438 15.578125 7.230469 13.351562 5 11.597656 L 5 5 C 5 4.449219 5.449219 4 6 4 Z M 10.5 8 C 10.222656 8 10 8.222656 10 8.5 C 10 8.777344 10.222656 9 10.5 9 C 10.777344 9 11 8.777344 11 8.5 C 11 8.222656 10.777344 8 10.5 8 Z M 13.5 8 C 13.222656 8 13 8.222656 13 8.5 C 13 8.777344 13.222656 9 13.5 9 C 13.777344 9 14 8.777344 14 8.5 C 14 8.222656 13.777344 8 13.5 8 Z M 4 8.1875 L 4 10.8125 C 3.300781 10.265625 2.707031 9.804688 2.316406 9.5 C 2.707031 9.195312 3.300781 8.734375 4 8.183594 Z M 20 8.1875 C 20.699219 8.734375 21.292969 9.195312 21.683594 9.5 C 21.292969 9.804688 20.699219 10.265625 20 10.8125 Z M 9.964844 10 C 9.902344 10.007812 9.835938 10.023438 9.773438 10.050781 C 9.527344 10.175781 9.429688 10.476562 9.550781 10.722656 C 9.578125 10.773438 10.210938 12 12 12 C 13.789062 12 14.421875 10.773438 14.449219 10.722656 C 14.570312 10.480469 14.472656 10.1875 14.230469 10.0625 C 13.984375 9.933594 13.6875 10.03125 13.558594 10.269531 C 13.539062 10.300781 13.148438 11 12 11 C 10.859375 11 10.464844 10.308594 10.441406 10.269531 C 10.347656 10.085938 10.160156 9.988281 9.964844 10.003906 Z M 2 10.519531 C 4.085938 12.144531 8.910156 15.929688 10.640625 17.464844 C 11.039062 17.816406 11.503906 18 11.984375 18 C 12.46875 18 12.953125 17.808594 13.34375 17.464844 C 15.140625 15.871094 20.0625 12.027344 22 10.519531 L 22 21 C 22 21.550781 21.550781 22 21 22 L 3 22 C 2.449219 22 2 21.550781 2 21 Z M 2 10.519531 "
            />
          </g>
        </svg>

        <span>Leave feedback</span>
      </a>
    </div>
  );
};

export default NavigationBanner;
